import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { Router } from '@angular/router';
import { BsCacheService, ServiceRoutes, routePath } from '@brightside-web/desktop/data-access/core-services';

@Component({
    selector: 'brightside-web-loans-application-action-card',
    templateUrl: './loans-application-action-card.component.html',
    styleUrls: ['./loans-application-action-card.component.scss'],
    imports: [BrightsideUiModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoansApplicationActionCardComponent {
  private _router: Router = inject(Router);
  private _bsCacheService: BsCacheService = inject(BsCacheService);
  data: { vendor: string };

  loansApplicationCardConfig: ActionCardConfigInterface = {
    label: 'TAKE_ACTION',
    labelBold: true,
    labelSub: 'LOAN_APPLICATION_MINUTES',
    labelSubRemoveDash: true,
    labelIcon: 'actions',
    labelIconSize: 22,
    title: 'LOAN_APPLICATION_TITLE',
    body: 'LOAN_APPLICATION_DESC',
    cardStyle: 'small',
    shadow: true,
    marginBottom: 'small'
  }

  routeToLoans() {
    this._bsCacheService.setItem('loanVendorFromCard', this.data?.vendor).then(() => {      
      this._router.navigate([routePath('loan_application')]);
    });
  }
}
